export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(800)]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(800)]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  root: {
    display: "flex",
    [theme.breakpoints.down(650)]: {
      marginBottom: 60,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    [theme.breakpoints.up(650)]: {
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  },
  inputRoot: {
    height: 70,
  },

  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  paper: {
    padding: 10,
    textAlign: "center",
  },
  feeRoot: {
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: `1px solid #181818`,
    [theme.breakpoints.down(960)]: {
      flexDirection: "column",
    },
  },
  tableStyle: {
    border: `1px solid #181818`,
  },
  listitemRoot: {
    display: "flex",
    [theme.breakpoints.down(960)]: {
      flexDirection: "column",
    },
  },
});
